import { createActionCreator } from 'deox';
import { HtmlDocumentType } from '@/types';

export const loadHtmlActions = {
  request: createActionCreator(
    'LOAD_HTML_REQUEST',
    (resolve) => (htmlDocumentType: HtmlDocumentType) => resolve({ htmlDocumentType }),
  ),
  success: createActionCreator(
    'LOAD_HTML_SUCCESS',
    (resolve) => (htmlDocumentType: HtmlDocumentType, html: string) =>
      resolve({ htmlDocumentType, html }),
  ),
  failure: createActionCreator('LOAD_HTML_FAILURE', (resolve) => (error: unknown) =>
    resolve({ error }),
  ),
};
